<template>
  <div class="modal fade" id="modal-reject-comment" tabindex="-1" role="dialog" aria-labelledby="modalRejectLabel" aria-hidden="true">
    <div class="modal-dialog" :class="modalSize" role="document">
      <div class="modal-content">
        <div class="modal-header bg-warning text-white">
          <h5 class="modal-title" id="modalRejectLabel">{{ title }}</h5>
          <button type="button" class="close text-white" data-bs-dismiss="modal" aria-label="Fermer">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <!-- SLOT pour contenu additionnel (ex : résumé de l'entité) -->
        <div class="modal-body">
          <slot name="context" />

          <textarea
              v-model="comment"
              class="form-control"
              :placeholder="placeholder"
              rows="4"
          ></textarea>

          <div v-if="error" class="text-danger mt-2">{{ error }}</div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" :disabled="loading" data-bs-dismiss="modal">Annuler</button>
          <button type="button" class="btn btn-warning" :disabled="loading" @click="submit">
            <i v-if="loading" class="spinner-border spinner-border-sm me-1"></i>
            {{ confirmButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ModalRejectComment',
    props: {
      title: {
        type: String,
        default: 'Motif du rejet'
      },
      placeholder: {
        type: String,
        default: 'Saisissez le motif du rejet...'
      },
      confirmButtonText: {
        type: String,
        default: 'Rejeter'
      },
      reference: {
        type: String,
        default: ''
      },
      entityId: {
        type: [String, Number],
        default: null
      },
      modalSize: {
        type: String,
        default: 'modal-md' // ou modal-lg / modal-xl
      }
    },
    data() {
      return {
        comment: '',
        error: '',
        loading: false
      };
    },
    methods: {
      open() {
        this.comment = '';
        this.error = '';
        $('#modal-reject-comment').modal('show');
      },
      close() {
        $('#modal-reject-comment').modal('hide');
      },
      async submit() {
        if (!this.comment || this.comment.trim() === '') {
          this.error = 'Le commentaire est requis.';
          return;
        }

        this.loading = true;
        try {
          await this.$emit('submit', {
            commentaire: this.comment.trim(),
            reference: this.reference,
            id: this.entityId
          });
          this.close();
        } finally {
          this.loading = false;
        }
      }
    }
  };
</script>
